import { TimeoutStepSchema } from '@feedyou/schema'

import { search } from './services/search'
import { getUsedDialogs } from './services/getUsedDialogs'
import { createStepService } from '../../utils/stepServices/createStepServices'
import { getSubdialogConnectionsMetadata } from './services/getSubdialogConnectionsMetadata'

export const timeoutStepService = createStepService<TimeoutStepSchema, {}>({
  search,

  getUsedDialogs,
  getSubdialogConnectionsMetadata
})
